import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "bcForm",
  class: "p-fluid p-formgrid p-grid p-mt-4 p-mx-2 kn-flex-0"
}
const _hoisted_2 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "desc",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "kn-relative kn-flex" }
const _hoisted_9 = { class: "table-header p-d-flex" }
const _hoisted_10 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("form", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, [
          _createVNode(_component_InputText, {
            id: "name",
            class: ["kn-material-input", {
                        'p-invalid': _ctx.v$.tmpBnssView.name.$invalid && _ctx.v$.tmpBnssView.name.$dirty
                    }],
            modelValue: _ctx.v$.tmpBnssView.name.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.tmpBnssView.name.$model = $event)),
            modelModifiers: { trim: true },
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.tmpBnssView.name.$touch())),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
          }, null, 8, ["modelValue", "class"]),
          _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " *", 1)
        ]),
        _createVNode(_component_KnValidationMessages, {
          class: "p-mt-1",
          vComp: _ctx.v$.tmpBnssView.name,
          additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
        }, null, 8, ["vComp", "additionalTranslateParams"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, [
          _createVNode(_component_InputText, {
            id: "desc",
            class: "kn-material-input",
            modelValue: _ctx.tmpBnssView.description,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.tmpBnssView.description = $event))
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.description')), 1)
        ])
      ])
    ], 512),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", {
        class: "kn-height-full kn-width-full",
        style: _ctx.bsDescriptor.style.absolute
      }, [
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm kn-table p-ml-2",
          value: _ctx.physicalModels,
          selection: _ctx.tmpBnssView.physicalModels,
          "onUpdate:selection": _cache[6] || (_cache[6] = ($event: any) => (_ctx.tmpBnssView.physicalModels = $event)),
          scrollable: true,
          scrollHeight: "100%",
          filters: _ctx.filters,
          "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filters = $event)),
          globalFilterFields: _ctx.bsDescriptor.globalFilterFields
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.')), 1)
          ]),
          header: _withCtx(() => [
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters['global'].value = $event)),
                  placeholder: _ctx.$t('common.search')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, { selectionMode: "multiple" }),
            _createVNode(_component_Column, {
              field: "name",
              header: _ctx.$t('common.name'),
              style: {"flex-basis":"100%"}
            }, null, 8, ["header"])
          ]),
          _: 1
        }, 8, ["value", "selection", "filters", "globalFilterFields"])
      ], 4)
    ])
  ], 64))
}